<template>
  <v-app class="pa-3">
    <v-overlay
      :opacity="1"
      :value="overlay"
      color="#fff"
    >
      <v-progress-circular
        indeterminate
        size="130"
        :width="2"
        color="pink darken-1"
      >
        <v-img
          width="80"
          src="@/assets/loader.gif"
        />
      </v-progress-circular>
    </v-overlay>
    <v-app-bar
      class="px-3"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-form ref="form">
        <v-container>
          <v-card
            class="mx-auto justify-center mb-6"
            :max-width="(isMobile ? 380 : 500)"
            :class="{'pa-6': !isMobile}"
            style="border-radius: 10px"
            :elevation="(isMobile ? 0 : 10)"
            :flat="isMobile"
          >
            <v-row
              :class="{'mx-0' : !isMobile}"
            >
              <v-card-title
                class="justify-start mt-4"
                :style="{'margin-top':(isMobile ? '40px !important' : '0px')}"
                grey
                style="width: 100%"
                darken-3
              >
                <h2>{{ $t('register') }}</h2>
              </v-card-title>
              <v-card-title
                class="justify-start my-4 mt-2"
                grey
                darken-3
              >
                {{ $t('forStartPleaseEnterYourPhone') }}
              </v-card-title>
              <v-col
                v-if="$route.query.in_"
                class="py-0 mb-10"
                cols="12"
              >
                <v-text-field
                  v-model="shopId"
                  :label="$t('InstageramUsername')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  :placeholder="$t('username')"
                  outlined
                  height="36"
                  clearable
                />
              </v-col>
              <v-col
                class="px-3 xs pt-0 mb-3"
                cols="12"
              >
                <v-text-field
                  v-model="phone"
                  :label="$t('mobile')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  placeholder="09123456789"
                  outlined
                  height="36"
                  type="number"
                  clearable
                />
                <!--                <vue-tel-->
                <!--                  v-model="phone"-->
                <!--                  :label="$t('mobile')"-->
                <!--                  :placeholder="$t('enterYourNumberWithoutPrefix')"-->
                <!--                  :rules="[v => !!v || $t('is-required')]"-->
                <!--                  dense-->
                <!--                  outlined-->
                <!--                  :only-countries="['IR']"-->
                <!--                  :disabled-fetching-country="true"-->
                <!--                  mode="international"-->
                <!--                  :max-len="11"-->
                <!--                  :input-options="{ showDialCode: false, tabindex: 0 }"-->
                <!--                  style="direction: ltr"-->
                <!--                  :valid-characters-only="true"-->
                <!--                  :disabled="checkCode"-->
                <!--                  @input="phoneCheck"-->
                <!--                />-->
              </v-col>
              <v-col
                v-if="checkCode"
                class="px-3 xs pt-3 mb-0"
                cols="12"
              >
                <v-text-field
                  v-model="code"
                  :label="$t('code')"
                  append-icon="mdi-key"
                  dense
                  height="36"
                  hide-details
                  outlined
                />
              </v-col>
              <v-col
                v-if="checkCode"
                class="xs py-0"
                style="display: flex"
                cols="12"
                md="12"
                sm="12"
              >
                <div
                  class="justify-right pOrrange--text my-3"
                  style="cursor: pointer;font-size: 12px"
                >
                  {{ $t('TheCodeSentToYourPhone') }}
                </div>
              </v-col>
              <v-col
                v-if="checkCode"
                class="xs py-0 mt-3"
                style="display: flex"
                cols="12"
                md="12"
                sm="12"
              >
                <div
                  class="mx-auto justify-center primary--text mt-2"
                  style="cursor: pointer;font-size: 14px"
                  @click="editEmail"
                >
                  {{ $t('editPhone') }}
                </div>
              </v-col>
              <v-col
                class="px-3  xs py-0 mt-7"
                cols="12"
              >
                <v-btn
                  v-shortkey="['enter']"
                  :loading="loading"
                  block
                  color="primary"
                  @shortkey="submit"
                  @click="submit"
                >
                  <p
                    class="mb-0 mx-auto"
                    style="font-size: 18px"
                  >
                    {{ $t('continue') }}
                  </p>
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                class="xs py-0"
                style="display: flex"
                cols="12"
                md="12"
                sm="12"
              >
                <div
                  class="mx-auto justify-center blue-grey--text text--darken-3 mt-4"
                  style="cursor: pointer;font-size: 16px"
                  @click="goTo('login')"
                >
                  {{ $t('iHaveAccount') }}
                </div>
              </v-col>
              <v-col cols="12" />
            </v-row>
          </v-card>
        </v-container>
      </v-form>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;"
      padless
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  // import VueTel from '../../components/general/vue-tel-input-vuetify/lib/vue-tel-input-vuetify'
  import Language from '../../components/core/LanguageBar'
  import axios from 'axios'
  export default {
    components: {
      Language,
      // VueTel,
    },
    mixins: [General],
    data () {
      return {
        lang: {
          id: 1,
          title: 'فارسی',
          lang: 'fa',
          rtl: true,
          flagSrc: 'https://www.countryflags.com/wp-content/uploads/iran-flag-png-large.png',
        },
        shopId: null,
        email: null,
        overlay: false,
        phonePrefix: null,
        plan: null,
        phone: null,
        checkCode: null,
        country: 'IRN',
        code: null,
        has_error: false,
        text_error: null,
        academy: null,
        loading: false,
      }
    },
    beforeMount () {
      // this.getCountry()
      this.country = 'IRN'
      if (this.$route.query.app_key) {
        this.appKey = this.$route.query.app_key
      } else {
        this.appKey = localStorage.getItem('APP_KEY')
      }
      if (this.$route.query.plan) {
        this.plan = this.$route.query.plan
      }
      if (this.$route.query.ac_) {
        this.academy = true
      }
    },
    mounted () {
    },
    methods: {
      phoneCheck (formattedNumber, { number, valid, country }) {
        this.phonePrefix = country.dialCode
        var phoneNumber = number.input.replace(/\s/g, '')
        phoneNumber = phoneNumber.replaceAll('-', '')
        phoneNumber = phoneNumber.replace('+', '')
        phoneNumber = phoneNumber.replace(/^0+/, '')
        this.phone = phoneNumber
      },
      getCountry () {
        var app = this
        fetch('https://ip2c.org/s')
          .then((response) => response.text())
          .then((response) => {
            const result = (response || '').toString()
            var array = result.split(';')
            app.country = array[2]
            var lang = {
              id: 2,
              title: 'English',
              lang: 'en',
              rtl: false,
              flagSrc: 'https://www.countryflags.com/wp-content/uploads/united-kingdom-flag-png-large.png',
            }
            if (app.country === 'IRN') {
              lang = {
                id: 1,
                title: 'فارسی',
                lang: 'fa',
                rtl: true,
                flagSrc: 'https://www.countryflags.com/wp-content/uploads/iran-flag-png-large.png',
              }
            }
            app.$refs.refLang.changeLanguage(lang)
          })
        setTimeout(function () {
          app.overlay = false
        }, 2000)
      },
      submit () {
        var app = this
        if (this.$route.query.in_) {
          // app.$router.push({ name: 'registerShop', params: { phonePrefixProp: app.phonePrefix, phoneProp: app.phone, shopProp: app.shopId } })
          // return false
        }
        app.loading = true
        delete axios.defaults.headers.common.Authorization
        app.$axios.post(this.$apipoint + 'register', app.$data)
          .then(res => {
            if (res.data.status === 'ok') {
              if (this.$route.query.in_) {
                app.$router.push({ name: 'registerShop', params: { phonePrefixProp: app.phonePrefix, phoneProp: app.phone, shopProp: app.shopId } })
              } else if (this.$route.query.ac_) {
                app.$router.push({ name: 'academyStudentRegister', params: { phonePrefixProp: app.phonePrefix, phoneProp: app.phone, keyProp: app.$route.query.app_key } })
              } else {
                app.$router.push({ name: 'registerPlan', params: { phonePrefixProp: app.phonePrefix, phoneProp: app.phone, planProp: app.plan } })
              }
            } else {
              app.checkCode = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.loading = false))
      },
      editEmail () {
        this.checkCode = false
        this.phone = null
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

<style scoped>
div.vue-tel-input-vuetify > .v-input {
  margin-inline-end: 8px !important;
}
</style>
